import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';

/**
 * Initialize native device features when running in a native app context
 */
export async function initializeNative() {
	// Check if running on a native platform
	if (!Capacitor.isNativePlatform()) {
		console.log('Running in web mode - skipping native initialization');
		return;
	}

	console.log('Running on native platform:', Capacitor.getPlatform());

	try {
		// Configure status bar
		if (Capacitor.getPlatform() === 'ios') {
			await StatusBar.setStyle({ style: Style.Dark });
		}

		// Configure keyboard behavior
		Keyboard.addListener('keyboardWillShow', (info) => {
			document.body.style.setProperty('--keyboard-height', `${info.keyboardHeight}px`);
		});

		Keyboard.addListener('keyboardWillHide', () => {
			document.body.style.setProperty('--keyboard-height', '0px');
		});

		// Hide splash screen after app is ready
		await SplashScreen.hide();
	} catch (error) {
		console.error('Error initializing native features:', error);
	}
}

/**
 * Check if the app is running in a native context
 */
export function isNative() {
	return Capacitor.isNativePlatform();
}

/**
 * Get the current platform (ios, android, or web)
 */
export function getPlatform() {
	return Capacitor.getPlatform();
}
